import { AccountData } from '@types';
import { ChurnNoticeButton } from '@/components/AccountDetails/ChurnNoticeButton';
import { DownsellButton } from '@/components/AccountDetails/DownsellButton';
import { UpsellButton } from '@/components/AccountDetails/UpsellButton';

export function ChurnRiskDetail({
  statusData,
  clientData,
}: {
  statusData: string;
  clientData: AccountData;
}) {
  return (
    <div className='w-full'>
      <div className='flex space-x-4'>
        <ChurnNoticeButton clientData={clientData} />
        <DownsellButton clientData={clientData} />
        <UpsellButton clientData={clientData} />
      </div>
      <div className='w-1/2 flex items-center text-lg font-bold'>
        Status Updates
      </div>
      {statusData.split('\n').map((line, index) => {
        const [firstWord, ...rest] = line.split(' ');
        const restOfLine = rest.join(' ');

        let color = '';
        if (firstWord.toLowerCase() === 'yellow') {
          color = 'var(--special-yellow)';
        } else if (firstWord.toLowerCase() === 'red') {
          color = 'red';
        } else if (firstWord.toLowerCase() === 'green') {
          color = 'green';
        }

        return (
          // eslint-disable-next-line react/no-array-index-key
          <div key={`status_${index}`} className='my-3'>
            {color ? (
              <>
                <span style={{ color, fontWeight: 'bold' }}>{firstWord}</span>{' '}
                {restOfLine}
              </>
            ) : (
              line
            )}
          </div>
        );
      })}
    </div>
  );
}
